module.exports = __webpack_public_path__ + "static/img/bg-pt.b3280872.png";